import { Utilities } from "./utilities";
import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import * as firebase from "firebase";
import { Observable } from "rxjs/Observable";
import { IStaff } from "../shared/models/staff.model";
import { HistoryData } from "./history";
import { _TRACKING_ENTITIES, TrackingProvider } from "./tracking";

@Injectable()
export class JobsData {

  private action: string = "update";

  constructor(
    private afDb: AngularFireDatabase,
    private tracking: TrackingProvider,
    private historyData: HistoryData,
    private utilities: Utilities,
  ) { }

  public createOrUpdateJob(clientId: string, job: any, eventId: string) {
    console.log("eventId ??", eventId)
    if (job.id === "") {
      this.action = "create";
      job.id = this.afDb.createPushId();
      job.created_at = new Date().getTime();
    } else {
      this.action = "update";
      job.update_at = new Date().getTime();
    }

    let reference = `Clients/${clientId}/Interactivity/Jobs/${job.id}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/Jobs/${job.id}`;
    }

    return new Promise((resolve, reject) => {
      return this.afDb.database
        .ref(reference)
        .update(job)
        .then(() => {
          this.tracking.trackEntityPromise(_TRACKING_ENTITIES.staff, job.id, clientId, eventId, job, "Creacion/actualizacion job");
          return true;
        })
        // .then(() => {
        //   return this.historyData.set(
        //     `Staff content`,
        //     "staff",
        //     this.action,
        //     staff,
        //   );
        // })
        .then(() => resolve(job))
        .catch((error) => {
          reject(error);
        });
    });
  }

  public getJobsByClientId(clientId: string, eventId: string): any {
    let reference = `Clients/${clientId}/Interactivity/Jobs`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/Jobs`;
    }
    return this.afDb.list<any>(reference).valueChanges();
  }

  public getJobByJobId(clientId: string, jobId: string, eventId: string): Observable<IStaff> {
    let reference = `Clients/${clientId}/Interactivity/Jobs/${jobId}`;
    if (this.utilities.validateEventIdParam(eventId)) {
      reference = `Clients/${clientId}/Event/${eventId}/Jobs/${jobId}`;
    }
    return this.afDb
      .object<any>(reference)
      .valueChanges();
  }

  public createOrUpdateStaffCategory(client: string, category: any) {
    if (category.id === "") {
      this.action = "create";
      category.id = this.afDb.createPushId();
      category.created_at = new Date().getTime();
    } else {
      this.action = "update";
      category.update_at = new Date().getTime();
    }
    return new Promise((resolve, reject) => {
      return this.afDb.database
        .ref(`Clients/${client}/StaffCategories/${category.id}`)
        .update(category)
        .then(() => {
          return this.historyData.set(
            `Staff category content`,
            "staff",
            this.action,
            category,
          );
        })
        .then(() => {
          resolve(category);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/jobs.ts